/* eslint-disable local/no-raw-colors */
import React from 'react'
import type { SvgProps } from 'react-native-svg'
import { Path, Rect, Svg } from 'react-native-svg'

export const CheckboxSelected: React.FC<SvgProps> = props => (
    <Svg viewBox='0 0 20 20' {...props}>
        <Rect x='1' y='1' rx='2' fill='#E5E5E6' stroke='#E5E5E6' strokeWidth='2' />
        <Path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M8.4125 14.8125L16.85 6.375L15.5125 5L8.4125 12.1375L5.075 8.775L3.75 10.1125L8.4125 14.8125Z'
            fill='#18181B'
        />
    </Svg>
)
